/**
 * Swaps a list-bound field's inline vocabulary for the resolved list's, so the
 * estimator measures what the column actually shows.
 *
 * Both frontend consumers did this themselves and disagreed about the empty
 * case: the schema page substituted whenever an entry existed, so a list still
 * loading (or one that failed) replaced the vocabulary with nothing and the
 * counter under-reported; the validator substituted only when the resolved list
 * had rows. On a cold cache the character counter and the Validate bar therefore
 * measured different arrays.
 *
 * This takes the validator's rule. An entry with no rows means "not resolved
 * yet", not "empty vocabulary", and the field's own snapshot is a better
 * estimate than one character — while still being clearly worse than the real
 * list, which is why it is only ever used for MEASURING. The mint resolves the
 * list properly and never reads this.
 */
export function substituteResolvedValues(fields, resolved) {
    return fields.map((field) => {
        if (!field.listRef?.listId)
            return field;
        const values = resolved[field.id]?.values;
        return values && values.length > 0 ? { ...field, values } : field;
    });
}
